import { AddEditAddressModal, useAddressModal, useAddressModalCallback } from "@shared/AddressModal";
import InvalidAddressModal from "../../../../PersonDetail/components/InvalidAddressModal";
import VerifyAddressModal from "../../../../PersonDetail/components/VerifyAddressModal";

const PropertyDetailsAddressModal = () => {
  const addressModal = useAddressModal("addEdit");
  const { getOnSubmit } = useAddressModalCallback();

  return (
    <AddEditAddressModal
      initAddress={addressModal.modalState.initAddress}
      show={addressModal.isOpen}
      onClose={addressModal.close}
      onSubmit={getOnSubmit()}
      title={addressModal.modalState.title}
      onSaveTxt="Save"
      hideAddressType={addressModal.modalState.hideAddressType}
    />
  );
};

const PropertyDetailsInvalidAddressModal = () => {
  const invalidModal = useAddressModal("invalid");
  const { getInvalidOnSubmit, getInvalidOnEdit } = useAddressModalCallback();

  return (
    <InvalidAddressModal
      address={invalidModal.modalState.address}
      show={invalidModal.isOpen}
      onClose={invalidModal.close}
      onSubmit={getInvalidOnSubmit()}
      onEdit={getInvalidOnEdit()}
    />
  );
};

const PropertyDetailsVerifyAddressModal = () => {
  const verifyModal = useAddressModal("verify");
  const { getVerifyOnSubmit, getVerifyOnEdit } = useAddressModalCallback();

  return (
    <VerifyAddressModal
      originalAddress={verifyModal.modalState.originalAddress}
      suggestedAddress={verifyModal.modalState.suggestedAddress}
      show={verifyModal.isOpen}
      onClose={verifyModal.close}
      onSubmit={getVerifyOnSubmit()}
      onEdit={getVerifyOnEdit()}
    />
  );
};

const AddressStandardizationModals = () => (
  <>
    <PropertyDetailsAddressModal />
    <PropertyDetailsInvalidAddressModal />
    <PropertyDetailsVerifyAddressModal />
  </>
);

export default AddressStandardizationModals;
